import { BASE_API_URL } from "../../../config";
import { authFetch } from "../../authHelper";

export const updateCommands = {
  //
  async updateCaptures() {
    const apiPath = `${BASE_API_URL}/api/UpdateCaptures`;
    const response = await authFetch(apiPath, {
      method: "POST",
    });
    return response;
  },

  async updateAliasName(aliasName) {
    const apiPath = `${BASE_API_URL}/api/auth/update-alias`;
    const response = await authFetch(apiPath, {
      method: "POST",
      body: JSON.stringify({ aliasName }),
    });
    return response;
  },

  async updateProfileVisibility(isPublic: boolean) {
    const apiPath = `${BASE_API_URL}/api/auth/update-profile-visibility`;
    const response = await authFetch(apiPath, {
      method: "POST",
      body: JSON.stringify({ isPublic }),
    });
    return response;
  },

  async updateBio(bio: string) {
    const apiPath = `${BASE_API_URL}/api/auth/update-bio`;
    const response = await authFetch(apiPath, {
      method: "POST",
      body: JSON.stringify({ bio }),
    });
    return response;
  },

  async updateProfilePicture(profilePicture: string | null) {
    const apiPath = `${BASE_API_URL}/api/auth/update-profile-picture`;
    const response = await authFetch(apiPath, {
      method: "POST",
      body: JSON.stringify({ profilePicture }),
    });
    return response;
  },

  async updateEmailPreference(promotionalEmails: boolean) {
    const apiPath = `${BASE_API_URL}/api/updateEmailPreference`;
    const response = await authFetch(apiPath, {
      method: "POST",
      body: JSON.stringify({ promotionalEmails }),
    });
    return response;
  },
};
